import { type Editor, posToDOMRect } from '@tiptap/react';
import type { FuseResult } from 'fuse.js';

import classes from './ChatSuggestionList.module.css';
import type { MentionSuggestion } from '#components/chat/hooks/useMentionExtension';

export interface ChatSuggestionListProps<EntryType> {
  editor: Editor;
  suggestion?: MentionSuggestion<EntryType>;
  onSelect: (entry: FuseResult<EntryType>) => void;
  formatEntry: (entry: FuseResult<EntryType>) => React.ReactNode;
}

export function ChatSuggestionList<EntryType>({
  editor,
  suggestion,
  onSelect,
  formatEntry,
}: ChatSuggestionListProps<EntryType>) {
  if (!suggestion) {
    return;
  }
  const pos = posToDOMRect(editor.view, editor.state.selection.from, editor.state.selection.to);

  return (
    <div className={classes.suggestion} style={{ '--top': `${pos.top}px`, '--left': `${pos.left}px` }}>
      {suggestion.items?.map((entry) => (
        <div key={entry.refIndex}>
          <button
            type="button"
            onClick={() => {
              onSelect(entry);
              return true;
            }}
          >
            {formatEntry(entry)}
          </button>
        </div>
      ))}
    </div>
  );
}
